import type { UserRole } from '@/common/db-typebox';
import { env } from '@/env';
import { useAuth } from '@/stores/AuthContext';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { PermissionLink, RequireAuth } from './PermissionLink';

type NavItem =
  | {
      type: 'link';
      label: string;
      to: string;
      permissions?: UserRole[];
    }
  | {
      type: 'href';
      label: string;
      href: string;
      permissions?: UserRole[];
    };

export const NavList = observer(() => {
  const location = useLocation();
  const auth = useAuth();

  const menuList: NavItem[] = [
    {
      type: 'link',
      label: 'Home',
      to: '/',
      permissions: ['user', 'admin'] as UserRole[],
    },
    {
      type: 'link',
      label: 'Live Chat',
      to: '/live-chat',
      permissions: ['admin'] as UserRole[],
    },
    {
      type: 'link',
      label: 'Pairings',
      to: '/pairing',
      permissions: ['user', 'admin'] as UserRole[],
    },
    {
      type: 'link',
      label: 'Menu',
      to: '/menu',
      permissions: ['user', 'admin'] as UserRole[],
    },
    {
      type: 'link',
      label: 'Wine List',
      to: '/wine-list',
      permissions: ['user', 'admin'] as UserRole[],
    },
    {
      type: 'href',
      label: 'Staff Companion',
      href: `${env().VITE_PAIRING_APP_URL}?user_id=${auth?.user?.id}`,
      permissions: ['user', 'admin'] as UserRole[],
    },
  ];

  return (
    <div className="relative flex gap-4">
      {menuList.map((menu) =>
        menu.type === 'link' ? (
          <PermissionLink
            key={menu.label}
            permissions={menu.permissions}
            to={menu.to}
          >
            <Button
              type="text"
              className={`relative px-4 py-2 transition-all duration-200 ${
                location.pathname === menu.to
                  ? '!text-white font-medium bg-[#247aef] hover:!bg-[#247aef] hover:opacity-90'
                  : 'text-muted-foreground hover:!bg-[#247aef] hover:!text-white'
              }`}
            >
              {menu.label}
            </Button>
          </PermissionLink>
        ) : (
          <RequireAuth
            key={menu.label}
            permissions={menu.permissions}
            fallback={null}
          >
            <Button
              type="text"
              className="relative px-4 py-2 transition-all duration-200 text-muted-foreground hover:!bg-[#247aef] hover:!text-white"
              onClick={() => {
                window.open(menu.href, '_blank');
              }}
            >
              {menu.label}
            </Button>
          </RequireAuth>
        ),
      )}
    </div>
  );
});
